import { useQueryClient } from "@tanstack/react-query";
import React from "react";

import { api } from "../../../utils/axios/Config";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import ShowMoreText from "../../shared/show-more";

const MessageCard = ({ message }) => {
  const queryClient = useQueryClient();
  const handleSeenMessage = async (messageId) => {
    const response = await api.get(`/messages/${messageId}/`);
    if (response.status === 200) {
      queryClient.invalidateQueries({ queryKey: ["getMessagesList"] });
    }
  };
  return (
    <div className="group relative   w-full">
      {!message?.seen && (
        <div className="absolute right-2 top-2 z-10">
          <div className="flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-full w-full animate-pulse  rounded-full bg-primary-90 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 items-center justify-center rounded-full bg-primary-50 text-[10px] font-bold text-white"></span>
          </div>
        </div>
      )}

      <div className="relative overflow-hidden rounded-xl bg-gradient-to-bl bg-white border p-[1px] shadow-md shadow-emerald-500/20 ">
        {!message?.seen ? (
          <div onClick={() => handleSeenMessage(message?.id)} className="z-[9999] absolute top-2 left-2 ">
            <img src="/images/eye-plus.svg" alt="" className="h-6 w-6" />
          </div>
        ) : (
          <img src="/images/seen.svg" alt="" className="h-6 w-6 z-[9999] absolute top-2 left-2" />
        )}
        <div className="relative flex items-center gap-4 rounded-xl  px-6 py-3 transition-all duration-300 ">
          <div className="flex flex-col items-start">
            <div className="w-full flex justify-between">
              <span className="text-sm font-semibold ">{message.title}</span>
            </div>

            <ShowMoreText
              lines={4}
              className="p-2 text-[12px] font-medium break-words text-slate-800  "
              anchorClass="text-blue-600 cursor-pointer text-[10px]"
            >
              {message.message || ""}
            </ShowMoreText>
          </div>
        </div>

        <div className="flex gap-1 items-center text-neutral-60 text-[10px] justify-end pt-2  w-fit mr-auto px-2">
          <p>{unixToPersianDay(message.creation_time)}</p> -<p>{unixToPersianTime(message.creation_time)}</p>
        </div>
      </div>
    </div>
  );
};

export default MessageCard;
